import React, { useState } from "react";
import { iconsEnum } from "../UiComponents/IconSelect";
import classNames from "classnames";

const ParkingSlotCategoryPreview = ({
  parkingSlotCategory,
  name = "5",
  price = 0.0,
  onClick = null,
  selected = false,
  className = "",
}) => {
  const [hovered, setHovered] = useState(false);

  let outline = "none";

  if (!parkingSlotCategory) {
    return <></>;
  }

  if (hovered || selected) {
    outline = `2px solid ${parkingSlotCategory.color.value}`;
  }

  return (
    <div>
      <div
        className={classNames(`parking-slot-category-preview ${className}`, {
          selected: "parking-slot-category-preview-selected",
        })}
        style={{ outline: outline }}
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
        onClick={onClick}
      >
        <div
          className="left-left"
          style={{ backgroundColor: parkingSlotCategory.color.value }}
        ></div>

        <div className="container-a">
          <div className="container-b">
            <div className="left">
              <div className="title-container">
                <div
                  className={`rounded-circle shadow-sm mr-2 border border-dark d-flex justify-content-center align-items-center`}
                >
                  <i
                    className={`campicon-${
                      iconsEnum[parkingSlotCategory.icon]
                    }`}
                    style={{ color: parkingSlotCategory.color.value }}
                  ></i>
                </div>
                <p
                  className={`title`}
                  style={{ color: parkingSlotCategory.color.value }}
                >
                  {parkingSlotCategory.name}
                </p>
              </div>

              <p className="text">
                {parkingSlotCategory.description
                  ?.split(/\r?\n/)
                  .map((line, index) => (
                    <span key={"line_" + index}>
                      {line}
                      <br />
                    </span>
                  ))}
              </p>

              <div className="number-price-container">
                <div className="number-container">
                  <span className="text">
                    Nr. <b>{name}</b>
                  </span>
                </div>
                <span className="price">{price} EUR / Nacht</span>
              </div>
            </div>

            {(parkingSlotCategory?.imageBase64 ??
              parkingSlotCategory?.image?.url) && (
              <div className="right">
                <div
                  className="image"
                  style={{
                    backgroundImage: `url('${
                      parkingSlotCategory?.imageBase64 ??
                      parkingSlotCategory?.image?.url
                    }')`,
                  }}
                ></div>
                {selected && <div className="selected-label">Ausgewählt</div>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParkingSlotCategoryPreview;
